import type { FaireProductEntity } from "../../entity_types/product";

export const p_txmj9tdafw: FaireProductEntity = {
  token: "p_txmj9tdafw",
  type: "product",
  name: "These Are My Lucky Mahjong Socks Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl:
    "https://cdn.faire.com/fastly/81ef611d51d22558bc75ae986a12c56c67934e7a6fdc5c91765858c8efdd1bcd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6195489bd7730777af68ce3ea6dcbc82b344db965e43e8ab51951f7b189a1721.jpeg",
    "https://cdn.faire.com/fastly/c619ea65434aab5e017c441c4fbea696e3b46229cd1d552a986633f6ec3bb6b1.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/398b79e7d5c1408b4d605cb4da86b8e636b77ce8434e2bab6f7c1ba181ca864a.jpeg",
    "https://cdn.faire.com/fastly/4d838418403ceab4d4fe4cc17cefd0a28c4de344b302420762550ff7338d6986.jpeg",
  ],
  priceDollars: 6.75,
  description:
    "Scientifically unproven, but spiritually essential. Slip these comfy socks on and let the tiles align in your favor. ✨🀄️\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:35.523Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
